/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductionMiniReference
 */
export interface ProductionMiniReference {
    /**
     * 
     * @type {number}
     * @memberof ProductionMiniReference
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionMiniReference
     */
    readonly name?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionMiniReference
     */
    readonly specialType?: number | null;
}

export function ProductionMiniReferenceFromJSON(json: any): ProductionMiniReference {
    return ProductionMiniReferenceFromJSONTyped(json, false);
}

export function ProductionMiniReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionMiniReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'specialType': !exists(json, 'special_type') ? undefined : json['special_type'],
    };
}

export function ProductionMiniReferenceToJSON(value?: ProductionMiniReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


